import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { TRUST_PILLARS, PROOF_STATS } from "@/lib/content";

export default function TrustPillars() {
  return (
    <section className="section-pad bg-[#EBE9E1]/60" data-testid="home-trust">
      <div className="container-sp">
        <div className="max-w-3xl">
          <div className="overline">Why trust us</div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#0D1B2A] mt-3 leading-tight">
            Why students trust us with one of the biggest decisions of their future.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {TRUST_PILLARS.map((t, i) => {
            const Icon = Icons[t.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={t.title}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.45, delay: i * 0.04 }}
                className="card-sp"
                data-testid={`trust-pillar-${i}`}
              >
                <div className="w-11 h-11 rounded-xl bg-[#0D1B2A] text-[#D7141A] flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-serif text-xl text-[#0D1B2A] mt-5">{t.title}</h3>
                <p className="text-sm text-[#4A5568] mt-2.5 leading-relaxed">{t.body}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 gap-4">
          {PROOF_STATS.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl bg-white border border-[#EFEEE8] p-6"
              data-testid={`trust-stat-${s.label}`}
            >
              <div className="font-serif text-3xl text-[#0D1B2A]">{s.value}</div>
              <div className="text-xs text-[#4A5568] mt-1.5 leading-snug">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
